import { Box, Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { useRef, useState } from 'react';

import { CloseIcon } from 'Asset/icon';
import FaceTracking from 'View/monitoring/component/face-tracking';
import { TextBold, TextRegular } from 'UiKit/typography';
import ButtonSolid from 'UiKit/button/buttonSolid';
import usePostPresenceClockIn from 'Domain/monitoring/usePostPresenceClockIn';

import useMonitoringState from 'View/monitoring/state';

import styles from './styles.module.css';

const PresenceModal = ({ shift, t }) => {
  const NOW = Date.now();

  const lastFacePositionRef = useRef(null);
  const lastMovementTimeRef = useRef(NOW);

  const [isFaceDetected, setIsFaceDectected] = useState(false);
  const { mutate: onSubmitPresenceClockIn } = usePostPresenceClockIn();
  const { updateState } = useMonitoringState();

  const onClickClockIn = () => onSubmitPresenceClockIn({ shift });
  const onTracking = (value) => setIsFaceDectected(value);
  const onClose = () => updateState({ selectedView: 'presence' });

  const faceDetectedLabel = isFaceDetected ? t('attendance.ensureFaceVisibleText') : t('attendance.faceNotDetectedText');

  return (
    <Modal isOpen={true} onClose={onClose}>
      <ModalOverlay />
      <ModalContent maxWidth={'400px'} borderRadius="8px">
        <Box className={styles['presence-modal__container']}>
          {/* Head */}

          <Box className={styles['presence-modal__section--head']}>
            <TextBold className={styles['title__text']}>{t('attendance.title')}</TextBold>
            <CloseIcon data-testid="close-icon" width="15px" height="15px" color="var(--color-semantic-text)" cursor="pointer" onClick={onClose} />
          </Box>

          {/* Content */}

          <Box className={styles['presence-modal__section--content']}>
            <TextBold className={styles['shift__text']}>{shift?.name}</TextBold>
            <TextRegular className={styles['time__text']}>{shift?.time}</TextRegular>
            <FaceTracking
              lastFacePositionRef={lastFacePositionRef}
              lastMovementTimeRef={lastMovementTimeRef}
              height="198px"
              width="352px"
              isOpen={true}
              className={styles['camera__video']}
              onTracking={onTracking}
              onCloseModal={onClose}
            />
            <TextRegular className={styles['camera-information__text']} color={isFaceDetected ? 'var(--color-semantic-text)' : 'var(--color-error50)'}>
              {faceDetectedLabel}
            </TextRegular>
          </Box>

          {/* Footer */}

          <Box className={styles['presence-modal__section--footer']}>
            <ButtonSolid className={styles['presence__button']} onClick={onClickClockIn} disabled={!isFaceDetected}>
              {t('attendance.clock_in')}
            </ButtonSolid>
          </Box>
        </Box>
      </ModalContent>
    </Modal>
  );
};

export default PresenceModal;
